import { gql } from '@apollo/client'

export const UPDATE_WALLET_MUTATION = gql`
  mutation UpdateWallet($input: UpdateWalletInput!) {
    updateWallet(input: $input) {
      message
    }
  }
`
